import {afterNextRender, Component, Inject, PLATFORM_ID} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterModule} from '@angular/router';
import {CommonModule} from "@angular/common";
import {filter} from "rxjs";
import { DOCUMENT } from '@angular/common';
import {StructuredDataService} from "@cybfed/core/utils/structured-data.service";
import {TicketToMoneyPipe} from "@cybfed/shared/pipes/ticket-to-money.pipe";
import {LocalizationService} from "@cybfed/core/services/localization.service";
import {HttpService} from "@cybfed/core/services/http.service";
import {UpdateMetaTags} from "@cybfed/core/utils/update-meta-tags";
import {environment} from "@shared-environments/environment";
import {StorageService} from "@cybfed/core/services/storage.service";
import {appConstants} from "@cybfed/constants";
import {DomainService} from "@cybfed/core/utils/domain-service";
import {WhiteLabelService} from "@cybfed/core/services/web-site/white-label-service";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {UserStore} from "@cybfed/core/store/user.store";
import {PageBuilderStore} from "@white-label/components/page-builder/page-builder.store";
import {MediaStore} from "@cybfed/ui-lib/forms/image-input/media-gallery/media.store";
import {MediaComponent} from "@cybfed/ui-lib/forms/image-input/media-gallery/media.component";
import {PageBuilderModel} from "@white-label/components/page-builder/models/page-builder.model";
import {FaviconService} from "@cybfed/core/services/favicon.service";
import {TranslateService} from "@ngx-translate/core";
import {SpinnerComponent} from "@cybfed/shared/components/spinner/spinner.component";
import {MeService} from "@cybfed/core/services/me.service";
import {Ga4Service} from "@cybfed/core/helpers/ga4.service";
declare let gtag: Function;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    MediaComponent,
    SpinnerComponent
  ],
  providers: [
    UpdateMetaTags,
    StructuredDataService,
    TicketToMoneyPipe,
    LocalizationService,
    HttpService,
    WhiteLabelService,
    PageBuilderStore,
    MainStoreService,
    UserStore,
    FaviconService,
    MediaStore,
    DomainService,
    SpinnerComponent,
    Ga4Service,
    MeService
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private localizations:any = [];
  public whiteLabel: any

  constructor(
      private metadata: UpdateMetaTags,
      private router: Router,
      private activatedRoute: ActivatedRoute,
      private localizationService: LocalizationService,
      private domainService: DomainService,
      private whiteLabelService: WhiteLabelService,
      private mainStoreService: MainStoreService,
      private pageBuilderStore: PageBuilderStore,
      private faviconService: FaviconService,
      private ga4: Ga4Service,
      private translateService: TranslateService,
      private userStore: UserStore,
      private meService: MeService,
      @Inject(DOCUMENT) private dom,
      @Inject(PLATFORM_ID) private platformId: any,
  ) {
    StorageService.setItem(StorageService.statics.projectDirectory, appConstants.PROJECT_DIRECTORY.WHITE_LABEL)
    this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateCanonicalUrl(environment.portalUrl + '/' +  this.router.url);
      this.router.events.pipe(
          filter((event) => event instanceof NavigationEnd)
      ).subscribe((event: any) => {
        // this.updateCanonicalUrl(environment.portalUrl + '/' +  this.router.url);
        // Track the page view with GA4
        this.ga4.trackEvent('page_view', {
          page_path: event.urlAfterRedirects,
          // Optionally include additional parameters like page_title or page_location
        })
      });
    });
    this.getReferralValue()
    this.localizationService.getLocalization().subscribe((data:any) => {
      this.localizations = data.data.localizations;
      const langs: any = [];
      const translatableObject:any = {};
      for(let key in this.localizations){
        langs.push({'lang': this.localizations[key].lang})
        translatableObject[this.localizations[key].lang] = '';
      }
      StorageService.setJsonItem(StorageService.statics.cache.regions, langs);
      StorageService.setJsonItem(StorageService.statics.cache.translationDefaultModel, translatableObject);
    })

    this.checkWhiteLabel()


    afterNextRender(() => {
      if(StorageService.getItem(StorageService.statics.token)){
        this.getProfileData()
      } else{
        this.userStore.currentUser = null;
      }

    });
  }

  getProfileData(){
    this.meService.getProfile().subscribe((data: any)=>{
      if (!data.hasError) {
        StorageService.setJsonItem(StorageService.statics.currentUser, {...data.data?.account, ...{userId: data.data?.account._id}});
        StorageService.setJsonItem(StorageService.statics.profileData, data.data?.account)
        StorageService.setItem(StorageService.statics.currency, data.data?.account.currency)
        this.userStore.currentUser = data.data?.account;
      }
    })
  }

  updateCanonicalUrl(url:string){
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement= this.dom.querySelector(`link[rel='canonical']`) || null
    if (element==null) {
      element= this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel','canonical')
    element.setAttribute('href',url)
  }

  getReferralValue(){
    this.activatedRoute.queryParams.subscribe(params => {
      let referral  = params['referral'] || null;
      if (referral) {
        StorageService.setItem('referral', referral);
      }
    });
  }


  checkWhiteLabel() {

    let hostname = this.domainService.hostname || 'localhost';
    if(hostname === 'localhost' && environment.whiteLabelId) {
      this.whiteLabelService.getById(environment.whiteLabelId).subscribe((data: any) => {
        if(!data.hasError){
          StorageService.setItem(StorageService.statics.whiteLabelId, data.data.whiteLabel._id)
          StorageService.setItem(StorageService.statics.lang, data.data.whiteLabel.language)
          StorageService.setJsonItem(StorageService.statics.whiteLabel, data.data.whiteLabel)
          this.whiteLabel = data.data.whiteLabel;
          this.mainStoreService.whiteLabel = data.data.whiteLabel;
          this.pageBuilderStore.page =  new PageBuilderModel(data.data.whiteLabel.pageBuilding);

          this.metadata.updateMetaTags({
            title: data.data.whiteLabel.metaTitle,
            description: data.data.whiteLabel.metaDescription,
            keywords: data.data.whiteLabel.favicon,
            cardImage: data.data.whiteLabel.metaImageUrl,
            image: data.data.whiteLabel.metaImageUrl
          });
          if(this.mainStoreService.whiteLabel.favicon){
            this.faviconService.changeFavicon(this.mainStoreService.whiteLabel.favicon);
          }
          this.mainStoreService.publisher = data.data.publisher

        }
      })
    }else {
      this.whiteLabelService.getSettingsByDomainName(hostname as string).subscribe((data: any) => {

        if(!data.hasError){
          StorageService.setItem(StorageService.statics.whiteLabelId, data.data.whiteLabel._id)
          StorageService.setJsonItem(StorageService.statics.whiteLabel, data.data.whiteLabel)
          StorageService.setItem(StorageService.statics.lang, data.data.whiteLabel.language)
          this.translateService.use(data.data.whiteLabel.language);
          this.whiteLabel = data.data.whiteLabel
          this.mainStoreService.whiteLabel = data.data.whiteLabel;
          this.pageBuilderStore.page =  new PageBuilderModel(data.data.whiteLabel.pageBuilding);
          this.metadata.updateMetaTags({
            title: data.data.whiteLabel.metaTitle,
            description: data.data.whiteLabel.metaDescription,
            keywords: data.data.whiteLabel.keywords,
            cardImage: data.data.whiteLabel.metaImageUrl,
            image: data.data.whiteLabel.metaImageUrl
          });
          if(this.mainStoreService.whiteLabel.favicon){
            this.faviconService.changeFavicon(this.mainStoreService.whiteLabel.favicon);
          }
          console.log(data.data);
          this.mainStoreService.publisher = data.data.publisher
        }
      })
    }
  }

}
